module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_0.fad24f1a.png";